export const REFERRAL_LP_KEY = 'referral_lp';
